import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { OrganizationPaymentAccount, PaymentAccount } from '@uzurv/clara';
import * as MobilityManagerActions from '../../../../store/mobility-manager/mobility-manager.actions';
import * as MobilityManagerSelectors from '../../../../store/mobility-manager/mobility-manager.selectors';
import { AbstractPaymentAccountFormData } from '../../../forms/payment-account/abstract-payment-account-form';
import { MobilityManagerPaymentAccountFormComponent } from '../../../forms/payment-account/mobility-manager-payment-account/mobility-manager-payment-account-form.component';

export interface MobilityManagerPaymentAccountDialogData extends AbstractPaymentAccountFormData {
  organizationPaymentAccount: OrganizationPaymentAccount;
}

@Component({
  selector: 'app-mobility-manager-payment-account-dialog',
  templateUrl: './mobility-manager-payment-account-dialog.dialog.html',
  styleUrls: ['./mobility-manager-payment-account-dialog.dialog.scss'],
  imports: [AsyncPipe, MobilityManagerPaymentAccountFormComponent],
  standalone: true
})
export class MobilityManagerPaymentAccountDialog {
  readonly store$ = inject(Store);
  readonly data = inject<MobilityManagerPaymentAccountDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<MobilityManagerPaymentAccountDialog>>(MatDialogRef);

  readonly isSubmitting$ = this.store$.select(MobilityManagerSelectors.getSubmittingPaymentAccount);

  handleCreatePaymentAccount(paymentAccount: PaymentAccount): void {
    this.store$.dispatch(
      MobilityManagerActions.CreateOrganizationPaymentAccount({
        dialogRef: this.dialogRef,
        organizationPaymentAccount: Object.assign(new OrganizationPaymentAccount(), this.data.organizationPaymentAccount, {
          default: false,
          paymentAccount
        })
      })
    );
  }

  handleUpdatePaymentAccount(paymentAccount: PaymentAccount): void {
    this.store$.dispatch(
      MobilityManagerActions.EditOrganizationPaymentAccount({
        dialogRef: this.dialogRef,
        organizationPaymentAccount: Object.assign(new OrganizationPaymentAccount(), this.data.organizationPaymentAccount, {
          paymentAccount
        })
      })
    );
  }
}
